module.exports = __webpack_public_path__ + "static/media/safari-technology-preview_256x256.5f1b342a.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/browser-logos/src/safari-technology-preview/safari-technology-preview_256x256.png
// module id = 2871
// module chunks = 0